

window['baseUrl']=':3000/';// /
window['baseUrl']='/';

window['apiUrl']='https://stellarfundglobal.net' 

window['basename']='/wp-user';
//window['basename']='';//'/wp-user';



//

//window['login']='signin';
window['login']='login';


/*


"homepage":"https://fundflex-financo.online/wp-user",


*/

//export const wpUser=`http://localhost:3000`;
export const wpUser=`https://stellarfundglobal.net/wp-user`;
export const baseUrl=`https://stellarfundglobal.net`;

export const production=true;
//export const wpUser=`/wp-user`;


//. //${window.location.hostname}